module.exports = __webpack_public_path__ + "img/dr.5647f845.svg";